/* eslint-disable */
export default {
  doNotCall: 'No llamar',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
